import * as React from "react";
import { Button } from "@mui/material";
import TextField from "@mui/material/TextField";
import { db, storage } from "../../firebase";
import { useEffect, useState } from "react";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import {
  addDoc,
  collection,
  getDocs,
  onSnapshot,
  Timestamp,
} from "firebase/firestore";
import Box from "@mui/material/Box";
import { useSnackbar } from "notistack";
import MyImageList from "./ImageList";

export default function Banner() {
  const { enqueueSnackbar } = useSnackbar();

  const [values, setValues] = React.useState({});

  const [image, setImage] = useState(null);

  const setDocData = () => {
    // Add a new document with a generated id.
    addDoc(collection(db, "banner"), values).then((docRef) => {
      enqueueSnackbar("Image Uploaded!", { variant: "success" });
      console.log("Document written with ID: ", docRef.id);
    });
  };

  const handleChangeImage = (e) => {
    if (e.target.files[0]) {
      setImage(e.target.files[0]);
    }
  };

  const handleUpload = () => {
    // Create a reference
    const storageRef = ref(storage, `banner/${image.lastModified}`);

    // upload file
    uploadBytes(storageRef, image).then((snapshot) => {
      // get download url
      getDownloadURL(snapshot.ref).then((url) => {
        // send data to Firestore
        values.imageURL = url;
        values.timestamp = Timestamp.now();
        setDocData();
      });
    });

    // 'file' comes from the Blob or File API
    /* const uploadTask = uploadBytesResumable(storageRef, image);
    uploadTask.on(
      "state_changed",
      ((snapshot) => {},
      (error) => {},
      () => {
        // Upload completed successfully, now we can get the download URL
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          console.log("File available at", downloadURL);
          setDocData(downloadURL);
        });
      })
    ); */
  };

  return (
    <div>
      <h2>App Banner</h2>

      <MyImageList />

      <Box sx={{ mb: 3 }}>
        <input type="file" onChange={handleChangeImage} />
      </Box>
      <Button
        onClick={handleUpload}
        variant="contained"
        disableElevation
        sx={{ width: 300, height: 40, borderRadius: 1 }}
      >
        Add Banner
      </Button>
    </div>
  );
}
